@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(469_837_443)
public val Res.string.comparison_no_last_year: StringResource by lazy {
      StringResource("string:comparison_no_last_year", "comparison_no_last_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69499, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96811, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61178, 63),
      ))
    }

@delegate:ResourceContentHash(-1_975_623_638)
public val Res.string.comparison_note_last_week: StringResource by lazy {
      StringResource("string:comparison_note_last_week", "comparison_note_last_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69571, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96907, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61242, 45),
      ))
    }

@delegate:ResourceContentHash(-1_221_833_132)
public val Res.string.comparison_note_last_year: StringResource by lazy {
      StringResource("string:comparison_note_last_year", "comparison_note_last_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69625, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 96973, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61288, 49),
      ))
    }

@delegate:ResourceContentHash(1_042_018_209)
public val Res.string.comparison_note_then: StringResource by lazy {
      StringResource("string:comparison_note_then", "comparison_note_then", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69671, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97027, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61338, 44),
      ))
    }

@delegate:ResourceContentHash(-717_549_881)
public val Res.string.comparison_points: StringResource by lazy {
      StringResource("string:comparison_points", "comparison_points", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69716, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97072, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61383, 57),
      ))
    }

@delegate:ResourceContentHash(-994_711_694)
public val Res.string.comparison_previous_week: StringResource by lazy {
      StringResource("string:comparison_previous_week", "comparison_previous_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69774, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97154, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61441, 52),
      ))
    }

@delegate:ResourceContentHash(567_121_980)
public val Res.string.comparison_rise: StringResource by lazy {
      StringResource("string:comparison_rise", "comparison_rise", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69831, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97235, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61494, 31),
      ))
    }

@delegate:ResourceContentHash(1_057_620_648)
public val Res.string.comparison_select: StringResource by lazy {
      StringResource("string:comparison_select", "comparison_select", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69863, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97283, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61526, 41),
      ))
    }

@delegate:ResourceContentHash(1_272_523_143)
public val Res.string.comparison_shifted_day: StringResource by lazy {
      StringResource("string:comparison_shifted_day", "comparison_shifted_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69905, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97337, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61568, 86),
      ))
    }

@delegate:ResourceContentHash(-421_043_576)
public val Res.string.comparison_shifted_week: StringResource by lazy {
      StringResource("string:comparison_shifted_week", "comparison_shifted_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 69980, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97440, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61655, 111),
      ))
    }

@delegate:ResourceContentHash(-225_890_299)
public val Res.string.comparison_show: StringResource by lazy {
      StringResource("string:comparison_show", "comparison_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70116, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97644, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61767, 51),
      ))
    }

@delegate:ResourceContentHash(1_059_273_868)
public val Res.string.comparison_spoken_down: StringResource by lazy {
      StringResource("string:comparison_spoken_down", "comparison_spoken_down", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70164, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97720, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61819, 58),
      ))
    }

@delegate:ResourceContentHash(473_017_635)
public val Res.string.comparison_spoken_last_week: StringResource by lazy {
      StringResource("string:comparison_spoken_last_week", "comparison_spoken_last_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70227, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97803, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61878, 67),
      ))
    }

@delegate:ResourceContentHash(-1_539_300_071)
public val Res.string.comparison_spoken_last_year: StringResource by lazy {
      StringResource("string:comparison_spoken_last_year", "comparison_spoken_last_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70311, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 97907, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61946, 67),
      ))
    }

@delegate:ResourceContentHash(1_260_478_242)
public val Res.string.comparison_spoken_no_data: StringResource by lazy {
      StringResource("string:comparison_spoken_no_data", "comparison_spoken_no_data", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70391, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98007, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62014, 57),
      ))
    }

@delegate:ResourceContentHash(-1_042_338_019)
public val Res.string.comparison_spoken_same: StringResource by lazy {
      StringResource("string:comparison_spoken_same", "comparison_spoken_same", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70457, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98085, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62072, 58),
      ))
    }

@delegate:ResourceContentHash(1_937_503_925)
public val Res.string.comparison_spoken_up: StringResource by lazy {
      StringResource("string:comparison_spoken_up", "comparison_spoken_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70516, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98152, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62131, 52),
      ))
    }

@delegate:ResourceContentHash(-1_379_529_665)
public val Res.string.comparison_summary: StringResource by lazy {
      StringResource("string:comparison_summary", "comparison_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70577, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98233, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62184, 50),
      ))
    }

@delegate:ResourceContentHash(531_295_820)
public val Res.string.comparison_this_period: StringResource by lazy {
      StringResource("string:comparison_this_period", "comparison_this_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70628, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98284, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62235, 46),
      ))
    }

@delegate:ResourceContentHash(42_755_594)
public val Res.string.comparison_this_week: StringResource by lazy {
      StringResource("string:comparison_this_week", "comparison_this_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70671, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98343, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62282, 40),
      ))
    }

@delegate:ResourceContentHash(-942_196_831)
public val Res.string.comparison_title: StringResource by lazy {
      StringResource("string:comparison_title", "comparison_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70716, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98400, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62323, 44),
      ))
    }

@delegate:ResourceContentHash(1_041_852_062)
public val Res.string.comparison_vs_last_week: StringResource by lazy {
      StringResource("string:comparison_vs_last_week", "comparison_vs_last_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70773, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98477, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62368, 47),
      ))
    }

@delegate:ResourceContentHash(125_036_750)
public val Res.string.comparison_vs_last_year: StringResource by lazy {
      StringResource("string:comparison_vs_last_year", "comparison_vs_last_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70833, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98553, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62416, 47),
      ))
    }

@delegate:ResourceContentHash(-1_547_725_775)
public val Res.string.comparison_week_over_week_title: StringResource by lazy {
      StringResource("string:comparison_week_over_week_title", "comparison_week_over_week_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70881, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98617, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62464, 59),
      ))
    }

@delegate:ResourceContentHash(1_739_867_967)
public val Res.string.comparison_week_to_date: StringResource by lazy {
      StringResource("string:comparison_week_to_date", "comparison_week_to_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 70949, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98697, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62524, 47),
      ))
    }

@delegate:ResourceContentHash(1_166_781_671)
public val Res.string.comparison_wow_description: StringResource by lazy {
      StringResource("string:comparison_wow_description", "comparison_wow_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71005, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 98777, 246),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62572, 146),
      ))
    }

@delegate:ResourceContentHash(13_129_502)
public val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71176, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99024, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62719, 27),
      ))
    }

@delegate:ResourceContentHash(-81_717_427)
public val Res.string.conflict_generic: StringResource by lazy {
      StringResource("string:conflict_generic", "conflict_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71208, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99072, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62747, 72),
      ))
    }

@delegate:ResourceContentHash(2_002_560_570)
public val Res.string.conflict_other_company: StringResource by lazy {
      StringResource("string:conflict_other_company", "conflict_other_company", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71269, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99173, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62820, 114),
      ))
    }

@delegate:ResourceContentHash(-275_430_150)
public val Res.string.conflict_same_owner: StringResource by lazy {
      StringResource("string:conflict_same_owner", "conflict_same_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71380, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99312, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62935, 87),
      ))
    }

@delegate:ResourceContentHash(-835_784_813)
public val Res.string.conflict_staff_blocked: StringResource by lazy {
      StringResource("string:conflict_staff_blocked", "conflict_staff_blocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71484, 198),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99428, 330),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63023, 194),
      ))
    }

@delegate:ResourceContentHash(632_905_361)
public val Res.string.conflict_staff_expired: StringResource by lazy {
      StringResource("string:conflict_staff_expired", "conflict_staff_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71683, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99759, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63218, 82),
      ))
    }

@delegate:ResourceContentHash(1_686_775_808)
public val Res.string.conflict_unavailable: StringResource by lazy {
      StringResource("string:conflict_unavailable", "conflict_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71762, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99862, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63301, 84),
      ))
    }

@delegate:ResourceContentHash(1_937_348_593)
public val Res.string.connectivity_back_online: StringResource by lazy {
      StringResource("string:connectivity_back_online", "connectivity_back_online", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71859, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 99999, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63386, 48),
      ))
    }

@delegate:ResourceContentHash(1_298_365_209)
public val Res.string.connectivity_offline: StringResource by lazy {
      StringResource("string:connectivity_offline", "connectivity_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 71920, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100088, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63435, 92),
      ))
    }

@delegate:ResourceContentHash(250_298_411)
public val Res.string.context_add_workplace: StringResource by lazy {
      StringResource("string:context_add_workplace", "context_add_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72029, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100253, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63528, 49),
      ))
    }

@delegate:ResourceContentHash(-2_060_853_628)
public val Res.string.context_assign_shift: StringResource by lazy {
      StringResource("string:context_assign_shift", "context_assign_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72075, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100319, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63578, 52),
      ))
    }

@delegate:ResourceContentHash(80_820_213)
public val Res.string.context_close_day: StringResource by lazy {
      StringResource("string:context_close_day", "context_close_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72132, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100396, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63631, 45),
      ))
    }

@delegate:ResourceContentHash(-1_349_707_150)
public val Res.string.context_edit_shift: StringResource by lazy {
      StringResource("string:context_edit_shift", "context_edit_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72178, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100454, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63677, 42),
      ))
    }

@delegate:ResourceContentHash(1_344_906_761)
public val Res.string.context_edit_workplace: StringResource by lazy {
      StringResource("string:context_edit_workplace", "context_edit_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72225, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100525, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63720, 50),
      ))
    }

@delegate:ResourceContentHash(1_483_755_449)
public val Res.string.context_no_rosters: StringResource by lazy {
      StringResource("string:context_no_rosters", "context_no_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72272, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100600, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63771, 70),
      ))
    }

@delegate:ResourceContentHash(101_614_895)
public val Res.string.context_open_employee: StringResource by lazy {
      StringResource("string:context_open_employee", "context_open_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72339, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100711, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63842, 45),
      ))
    }

@delegate:ResourceContentHash(275_736_144)
public val Res.string.context_rosters: StringResource by lazy {
      StringResource("string:context_rosters", "context_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72397, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100781, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63888, 35),
      ))
    }

@delegate:ResourceContentHash(2_027_693_029)
public val Res.string.context_show_day: StringResource by lazy {
      StringResource("string:context_show_day", "context_show_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72433, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100825, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63924, 40),
      ))
    }

@delegate:ResourceContentHash(-485_044_316)
public val Res.string.context_show_next_shift: StringResource by lazy {
      StringResource("string:context_show_next_shift", "context_show_next_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72478, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100886, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63965, 59),
      ))
    }

@delegate:ResourceContentHash(-1_573_761_737)
public val Res.string.context_unassign_shift: StringResource by lazy {
      StringResource("string:context_unassign_shift", "context_unassign_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72546, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 100982, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64025, 42),
      ))
    }

@delegate:ResourceContentHash(906_508_782)
public val Res.string.context_your_workplaces: StringResource by lazy {
      StringResource("string:context_your_workplaces", "context_your_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72601, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101057, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64068, 51),
      ))
    }

@delegate:ResourceContentHash(502_608_258)
public val Res.string.contract_b2b: StringResource by lazy {
      StringResource("string:contract_b2b", "contract_b2b", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72649, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101121, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64120, 76),
      ))
    }

@delegate:ResourceContentHash(-1_333_521_102)
public val Res.string.contract_civil: StringResource by lazy {
      StringResource("string:contract_civil", "contract_civil", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72738, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101274, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64197, 62),
      ))
    }

@delegate:ResourceContentHash(1_345_617_040)
public val Res.string.contract_employment: StringResource by lazy {
      StringResource("string:contract_employment", "contract_employment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72781, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101365, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64260, 63),
      ))
    }

@delegate:ResourceContentHash(-797_467_413)
public val Res.string.contract_owner_partner: StringResource by lazy {
      StringResource("string:contract_owner_partner", "contract_owner_partner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72829, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101457, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64324, 70),
      ))
    }

@delegate:ResourceContentHash(-1_795_290_382)
public val Res.string.contract_short_b2b: StringResource by lazy {
      StringResource("string:contract_short_b2b", "contract_short_b2b", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72908, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101564, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64395, 30),
      ))
    }

@delegate:ResourceContentHash(2_022_497_302)
public val Res.string.contract_short_civil: StringResource by lazy {
      StringResource("string:contract_short_civil", "contract_short_civil", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72939, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101595, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64426, 52),
      ))
    }

@delegate:ResourceContentHash(-1_439_741_846)
public val Res.string.contract_short_employment: StringResource by lazy {
      StringResource("string:contract_short_employment", "contract_short_employment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 72980, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101648, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64479, 61),
      ))
    }

@delegate:ResourceContentHash(98_872_385)
public val Res.string.contract_short_owner: StringResource by lazy {
      StringResource("string:contract_short_owner", "contract_short_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73034, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101726, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64541, 52),
      ))
    }

@delegate:ResourceContentHash(-267_430_831)
public val Res.string.contract_short_specific_task: StringResource by lazy {
      StringResource("string:contract_short_specific_task", "contract_short_specific_task", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73099, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101803, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64594, 56),
      ))
    }

@delegate:ResourceContentHash(-1_563_049_023)
public val Res.string.contract_specific_task: StringResource by lazy {
      StringResource("string:contract_specific_task", "contract_specific_task", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73148, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101856, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64651, 78),
      ))
    }

@delegate:ResourceContentHash(1_790_174_816)
public val Res.string.copy_applied: StringResource by lazy {
      StringResource("string:copy_applied", "copy_applied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73199, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 101951, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64730, 48),
      ))
    }

@delegate:ResourceContentHash(1_503_427_569)
public val Res.string.copy_day_calendar_closed: StringResource by lazy {
      StringResource("string:copy_day_calendar_closed", "copy_day_calendar_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73252, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102024, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64779, 40),
      ))
    }

@delegate:ResourceContentHash(-1_762_449_832)
public val Res.string.copy_day_calendar_planned: StringResource by lazy {
      StringResource("string:copy_day_calendar_planned", "copy_day_calendar_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73309, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102097, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64820, 49),
      ))
    }

@delegate:ResourceContentHash(-284_806_051)
public val Res.string.copy_day_calendar_source: StringResource by lazy {
      StringResource("string:copy_day_calendar_source", "copy_day_calendar_source", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73363, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102159, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64870, 48),
      ))
    }

@delegate:ResourceContentHash(-1_130_659_486)
public val Res.string.copy_day_clear: StringResource by lazy {
      StringResource("string:copy_day_clear", "copy_day_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73420, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102236, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64919, 30),
      ))
    }

@delegate:ResourceContentHash(435_858_335)
public val Res.string.copy_day_day_alongside: StringResource by lazy {
      StringResource("string:copy_day_day_alongside", "copy_day_day_alongside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73455, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102283, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64950, 78),
      ))
    }

@delegate:ResourceContentHash(982_740_050)
public val Res.string.copy_day_day_kept: StringResource by lazy {
      StringResource("string:copy_day_day_kept", "copy_day_day_kept", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73538, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102402, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65029, 105),
      ))
    }

@delegate:ResourceContentHash(-1_318_749_406)
public val Res.string.copy_day_day_replaces: StringResource by lazy {
      StringResource("string:copy_day_day_replaces", "copy_day_day_replaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73656, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102584, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65135, 69),
      ))
    }

@delegate:ResourceContentHash(-933_907_162)
public val Res.string.copy_day_every_fri: StringResource by lazy {
      StringResource("string:copy_day_every_fri", "copy_day_every_fri", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73734, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102674, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65205, 62),
      ))
    }

@delegate:ResourceContentHash(-1_637_810_217)
public val Res.string.copy_day_every_mon: StringResource by lazy {
      StringResource("string:copy_day_every_mon", "copy_day_every_mon", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73797, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102757, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65268, 62),
      ))
    }

@delegate:ResourceContentHash(280_898_801)
public val Res.string.copy_day_every_sat: StringResource by lazy {
      StringResource("string:copy_day_every_sat", "copy_day_every_sat", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73868, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102840, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65331, 62),
      ))
    }

@delegate:ResourceContentHash(-984_720_643)
public val Res.string.copy_day_every_sun: StringResource by lazy {
      StringResource("string:copy_day_every_sun", "copy_day_every_sun", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73931, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102915, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65394, 62),
      ))
    }

@delegate:ResourceContentHash(-186_531_594)
public val Res.string.copy_day_every_thu: StringResource by lazy {
      StringResource("string:copy_day_every_thu", "copy_day_every_thu", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 73998, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 102990, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65457, 62),
      ))
    }

@delegate:ResourceContentHash(1_682_330_098)
public val Res.string.copy_day_every_tue: StringResource by lazy {
      StringResource("string:copy_day_every_tue", "copy_day_every_tue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74061, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103065, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65520, 62),
      ))
    }

@delegate:ResourceContentHash(683_348_519)
public val Res.string.copy_day_every_wed: StringResource by lazy {
      StringResource("string:copy_day_every_wed", "copy_day_every_wed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74124, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103148, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65583, 66),
      ))
    }

@delegate:ResourceContentHash(-1_235_327_393)
public val Res.string.copy_day_line: StringResource by lazy {
      StringResource("string:copy_day_line", "copy_day_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74246, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103286, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65709, 37),
      ))
    }

@delegate:ResourceContentHash(-1_808_835_851)
public val Res.string.copy_day_line_from: StringResource by lazy {
      StringResource("string:copy_day_line_from", "copy_day_line_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74187, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103223, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65650, 58),
      ))
    }

@delegate:ResourceContentHash(942_328_856)
public val Res.string.copy_day_menu_copy: StringResource by lazy {
      StringResource("string:copy_day_menu_copy", "copy_day_menu_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74284, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103324, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65747, 46),
      ))
    }

@delegate:ResourceContentHash(2_061_444_800)
public val Res.string.copy_day_nothing_on_day: StringResource by lazy {
      StringResource("string:copy_day_nothing_on_day", "copy_day_nothing_on_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74335, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103399, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65794, 75),
      ))
    }

@delegate:ResourceContentHash(1_806_729_884)
public val Res.string.copy_day_nothing_on_targets: StringResource by lazy {
      StringResource("string:copy_day_nothing_on_targets", "copy_day_nothing_on_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74419, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103523, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65870, 95),
      ))
    }

@delegate:ResourceContentHash(-249_527_792)
public val Res.string.copy_day_skipped_closed: StringResource by lazy {
      StringResource("string:copy_day_skipped_closed", "copy_day_skipped_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74515, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103659, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65966, 55),
      ))
    }

@delegate:ResourceContentHash(231_021_596)
public val Res.string.copy_day_skipped_planned: StringResource by lazy {
      StringResource("string:copy_day_skipped_planned", "copy_day_skipped_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74575, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103735, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66022, 84),
      ))
    }

@delegate:ResourceContentHash(-1_089_329_907)
public val Res.string.copy_day_whole_week: StringResource by lazy {
      StringResource("string:copy_day_whole_week", "copy_day_whole_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74656, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103860, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66107, 43),
      ))
    }

@delegate:ResourceContentHash(-1_086_099_711)
public val Res.string.copy_days_back: StringResource by lazy {
      StringResource("string:copy_days_back", "copy_days_back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74704, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103924, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66151, 30),
      ))
    }

@delegate:ResourceContentHash(-2_113_337_424)
public val Res.string.copy_days_calendar_sources: StringResource by lazy {
      StringResource("string:copy_days_calendar_sources", "copy_days_calendar_sources", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74735, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 103963, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66182, 50),
      ))
    }

@delegate:ResourceContentHash(-778_246_404)
public val Res.string.copy_days_calendar_start: StringResource by lazy {
      StringResource("string:copy_days_calendar_start", "copy_days_calendar_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74794, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104046, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66233, 56),
      ))
    }

@delegate:ResourceContentHash(1_277_154_937)
public val Res.string.copy_days_calendar_target: StringResource by lazy {
      StringResource("string:copy_days_calendar_target", "copy_days_calendar_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74855, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104139, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66290, 49),
      ))
    }

@delegate:ResourceContentHash(863_831_079)
public val Res.string.copy_days_copied: StringResource by lazy {
      StringResource("string:copy_days_copied", "copy_days_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 74905, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104205, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66340, 124),
      ))
    }

@delegate:ResourceContentHash(-855_933_142)
public val Res.string.copy_days_menu_copy_selected: StringResource by lazy {
      StringResource("string:copy_days_menu_copy_selected", "copy_days_menu_copy_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75026, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104390, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66465, 68),
      ))
    }

@delegate:ResourceContentHash(952_222_822)
public val Res.string.copy_days_menu_paste: StringResource by lazy {
      StringResource("string:copy_days_menu_paste", "copy_days_menu_paste", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75165, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104589, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66612, 56),
      ))
    }

@delegate:ResourceContentHash(1_218_788_950)
public val Res.string.copy_days_menu_paste_selected: StringResource by lazy {
      StringResource("string:copy_days_menu_paste_selected", "copy_days_menu_paste_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75091, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104483, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66534, 77),
      ))
    }

@delegate:ResourceContentHash(1_708_256_274)
public val Res.string.copy_days_outside_month: StringResource by lazy {
      StringResource("string:copy_days_outside_month", "copy_days_outside_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75218, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104674, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66669, 87),
      ))
    }

@delegate:ResourceContentHash(-1_847_739_523)
public val Res.string.copy_from_alongside: StringResource by lazy {
      StringResource("string:copy_from_alongside", "copy_from_alongside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75298, 119),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104786, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66757, 111),
      ))
    }

@delegate:ResourceContentHash(760_381_589)
public val Res.string.copy_from_confirm: StringResource by lazy {
      StringResource("string:copy_from_confirm", "copy_from_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75418, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 104966, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66869, 33),
      ))
    }

@delegate:ResourceContentHash(-1_923_680_729)
public val Res.string.copy_from_drafts: StringResource by lazy {
      StringResource("string:copy_from_drafts", "copy_from_drafts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75452, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105016, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66903, 100),
      ))
    }

@delegate:ResourceContentHash(-2_046_534_205)
public val Res.string.copy_from_kept_clocked: StringResource by lazy {
      StringResource("string:copy_from_kept_clocked", "copy_from_kept_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75561, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105205, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67004, 90),
      ))
    }

@delegate:ResourceContentHash(854_950_769)
public val Res.string.copy_from_kept_swap: StringResource by lazy {
      StringResource("string:copy_from_kept_swap", "copy_from_kept_swap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75664, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105368, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67095, 95),
      ))
    }

@delegate:ResourceContentHash(1_515_629_858)
public val Res.string.copy_from_labour: StringResource by lazy {
      StringResource("string:copy_from_labour", "copy_from_labour", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75796, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105520, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67191, 104),
      ))
    }

@delegate:ResourceContentHash(705_146_116)
public val Res.string.copy_from_left_open: StringResource by lazy {
      StringResource("string:copy_from_left_open", "copy_from_left_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75917, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105705, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67296, 71),
      ))
    }

@delegate:ResourceContentHash(880_484_643)
public val Res.string.copy_from_nothing: StringResource by lazy {
      StringResource("string:copy_from_nothing", "copy_from_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 75981, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105797, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67368, 101),
      ))
    }

@delegate:ResourceContentHash(-2_014_478_216)
public val Res.string.copy_from_previewing: StringResource by lazy {
      StringResource("string:copy_from_previewing", "copy_from_previewing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76091, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 105943, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67470, 64),
      ))
    }

@delegate:ResourceContentHash(-2_027_684_345)
public val Res.string.copy_from_reason_absent: StringResource by lazy {
      StringResource("string:copy_from_reason_absent", "copy_from_reason_absent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76160, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106048, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67535, 63),
      ))
    }

@delegate:ResourceContentHash(-727_257_502)
public val Res.string.copy_from_reason_double_booked: StringResource by lazy {
      StringResource("string:copy_from_reason_double_booked", "copy_from_reason_double_booked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76236, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106140, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67599, 74),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString8Resources(map: MutableMap<String, StringResource>) {
  map.put("comparison_no_last_year", Res.string.comparison_no_last_year)
  map.put("comparison_note_last_week", Res.string.comparison_note_last_week)
  map.put("comparison_note_last_year", Res.string.comparison_note_last_year)
  map.put("comparison_note_then", Res.string.comparison_note_then)
  map.put("comparison_points", Res.string.comparison_points)
  map.put("comparison_previous_week", Res.string.comparison_previous_week)
  map.put("comparison_rise", Res.string.comparison_rise)
  map.put("comparison_select", Res.string.comparison_select)
  map.put("comparison_shifted_day", Res.string.comparison_shifted_day)
  map.put("comparison_shifted_week", Res.string.comparison_shifted_week)
  map.put("comparison_show", Res.string.comparison_show)
  map.put("comparison_spoken_down", Res.string.comparison_spoken_down)
  map.put("comparison_spoken_last_week", Res.string.comparison_spoken_last_week)
  map.put("comparison_spoken_last_year", Res.string.comparison_spoken_last_year)
  map.put("comparison_spoken_no_data", Res.string.comparison_spoken_no_data)
  map.put("comparison_spoken_same", Res.string.comparison_spoken_same)
  map.put("comparison_spoken_up", Res.string.comparison_spoken_up)
  map.put("comparison_summary", Res.string.comparison_summary)
  map.put("comparison_this_period", Res.string.comparison_this_period)
  map.put("comparison_this_week", Res.string.comparison_this_week)
  map.put("comparison_title", Res.string.comparison_title)
  map.put("comparison_vs_last_week", Res.string.comparison_vs_last_week)
  map.put("comparison_vs_last_year", Res.string.comparison_vs_last_year)
  map.put("comparison_week_over_week_title", Res.string.comparison_week_over_week_title)
  map.put("comparison_week_to_date", Res.string.comparison_week_to_date)
  map.put("comparison_wow_description", Res.string.comparison_wow_description)
  map.put("confirm", Res.string.confirm)
  map.put("conflict_generic", Res.string.conflict_generic)
  map.put("conflict_other_company", Res.string.conflict_other_company)
  map.put("conflict_same_owner", Res.string.conflict_same_owner)
  map.put("conflict_staff_blocked", Res.string.conflict_staff_blocked)
  map.put("conflict_staff_expired", Res.string.conflict_staff_expired)
  map.put("conflict_unavailable", Res.string.conflict_unavailable)
  map.put("connectivity_back_online", Res.string.connectivity_back_online)
  map.put("connectivity_offline", Res.string.connectivity_offline)
  map.put("context_add_workplace", Res.string.context_add_workplace)
  map.put("context_assign_shift", Res.string.context_assign_shift)
  map.put("context_close_day", Res.string.context_close_day)
  map.put("context_edit_shift", Res.string.context_edit_shift)
  map.put("context_edit_workplace", Res.string.context_edit_workplace)
  map.put("context_no_rosters", Res.string.context_no_rosters)
  map.put("context_open_employee", Res.string.context_open_employee)
  map.put("context_rosters", Res.string.context_rosters)
  map.put("context_show_day", Res.string.context_show_day)
  map.put("context_show_next_shift", Res.string.context_show_next_shift)
  map.put("context_unassign_shift", Res.string.context_unassign_shift)
  map.put("context_your_workplaces", Res.string.context_your_workplaces)
  map.put("contract_b2b", Res.string.contract_b2b)
  map.put("contract_civil", Res.string.contract_civil)
  map.put("contract_employment", Res.string.contract_employment)
  map.put("contract_owner_partner", Res.string.contract_owner_partner)
  map.put("contract_short_b2b", Res.string.contract_short_b2b)
  map.put("contract_short_civil", Res.string.contract_short_civil)
  map.put("contract_short_employment", Res.string.contract_short_employment)
  map.put("contract_short_owner", Res.string.contract_short_owner)
  map.put("contract_short_specific_task", Res.string.contract_short_specific_task)
  map.put("contract_specific_task", Res.string.contract_specific_task)
  map.put("copy_applied", Res.string.copy_applied)
  map.put("copy_day_calendar_closed", Res.string.copy_day_calendar_closed)
  map.put("copy_day_calendar_planned", Res.string.copy_day_calendar_planned)
  map.put("copy_day_calendar_source", Res.string.copy_day_calendar_source)
  map.put("copy_day_clear", Res.string.copy_day_clear)
  map.put("copy_day_day_alongside", Res.string.copy_day_day_alongside)
  map.put("copy_day_day_kept", Res.string.copy_day_day_kept)
  map.put("copy_day_day_replaces", Res.string.copy_day_day_replaces)
  map.put("copy_day_every_fri", Res.string.copy_day_every_fri)
  map.put("copy_day_every_mon", Res.string.copy_day_every_mon)
  map.put("copy_day_every_sat", Res.string.copy_day_every_sat)
  map.put("copy_day_every_sun", Res.string.copy_day_every_sun)
  map.put("copy_day_every_thu", Res.string.copy_day_every_thu)
  map.put("copy_day_every_tue", Res.string.copy_day_every_tue)
  map.put("copy_day_every_wed", Res.string.copy_day_every_wed)
  map.put("copy_day_line", Res.string.copy_day_line)
  map.put("copy_day_line_from", Res.string.copy_day_line_from)
  map.put("copy_day_menu_copy", Res.string.copy_day_menu_copy)
  map.put("copy_day_nothing_on_day", Res.string.copy_day_nothing_on_day)
  map.put("copy_day_nothing_on_targets", Res.string.copy_day_nothing_on_targets)
  map.put("copy_day_skipped_closed", Res.string.copy_day_skipped_closed)
  map.put("copy_day_skipped_planned", Res.string.copy_day_skipped_planned)
  map.put("copy_day_whole_week", Res.string.copy_day_whole_week)
  map.put("copy_days_back", Res.string.copy_days_back)
  map.put("copy_days_calendar_sources", Res.string.copy_days_calendar_sources)
  map.put("copy_days_calendar_start", Res.string.copy_days_calendar_start)
  map.put("copy_days_calendar_target", Res.string.copy_days_calendar_target)
  map.put("copy_days_copied", Res.string.copy_days_copied)
  map.put("copy_days_menu_copy_selected", Res.string.copy_days_menu_copy_selected)
  map.put("copy_days_menu_paste", Res.string.copy_days_menu_paste)
  map.put("copy_days_menu_paste_selected", Res.string.copy_days_menu_paste_selected)
  map.put("copy_days_outside_month", Res.string.copy_days_outside_month)
  map.put("copy_from_alongside", Res.string.copy_from_alongside)
  map.put("copy_from_confirm", Res.string.copy_from_confirm)
  map.put("copy_from_drafts", Res.string.copy_from_drafts)
  map.put("copy_from_kept_clocked", Res.string.copy_from_kept_clocked)
  map.put("copy_from_kept_swap", Res.string.copy_from_kept_swap)
  map.put("copy_from_labour", Res.string.copy_from_labour)
  map.put("copy_from_left_open", Res.string.copy_from_left_open)
  map.put("copy_from_nothing", Res.string.copy_from_nothing)
  map.put("copy_from_previewing", Res.string.copy_from_previewing)
  map.put("copy_from_reason_absent", Res.string.copy_from_reason_absent)
  map.put("copy_from_reason_double_booked", Res.string.copy_from_reason_double_booked)
}
